import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Button, Container, Divider, Grid, Header, Icon, Input, Label, Segment, SemanticICONS } from 'semantic-ui-react';
import * as Ordini from '..';
import { ApplicationState } from '../..';
import { Matricola } from '../../core-assistenza';
import { ConsumabileMatricola, OrdineRiga } from '../models';
import RiepilogoOrdine from './RiepilogoOrdine';

type OwnProps = {
    matricola: Matricola,
    onConsumabiliInseriti: () => void,
    onGoBack: (step: number) => void
}

const connector = connect(
    (state: ApplicationState) => ({
        consumabili: state.ordini.consumabili.lista,
    }),
    Ordini.actions
)

type PropsFromRedux = ConnectedProps<typeof connector>

type SelezionaConsumabiliMatricolaProps =
    OwnProps &
    PropsFromRedux

type SelezionaConsumabiliMatricolaState = {
    consumabili: ConsumabileMatricola[]
}

class SelezionaConsumabiliMatricola extends React.Component<SelezionaConsumabiliMatricolaProps, SelezionaConsumabiliMatricolaState> {
    constructor(props: SelezionaConsumabiliMatricolaProps) {
        super(props);

        this.state = {
            consumabili: []
        };

        this.renderElencoConsumabili = this.renderElencoConsumabili.bind(this);
        this.renderConsumabile = this.renderConsumabile.bind(this);
        this.onConfermaClick = this.onConfermaClick.bind(this);
        this.onSelezionaAltraMacchinaClick = this.onSelezionaAltraMacchinaClick.bind(this);
        this.onAggiungiClick = this.onAggiungiClick.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onQtaChange = this.onQtaChange.bind(this);
        this.canContinue = this.canContinue.bind(this);
    }

    componentDidMount() {
        this.props.loadConsumabili(this.props.matricola.idSpecifica);
    }

    componentDidUpdate(propsPrecedenti: SelezionaConsumabiliMatricolaProps, statePrecedente: SelezionaConsumabiliMatricolaState) {
        if (this.props.consumabili.length !== propsPrecedenti.consumabili.length ||
            (this.state.consumabili.length === 0 && statePrecedente.consumabili.length === 0)) {
            this.props.consumabili.forEach(consumabile => {
                this.state.consumabili.push(consumabile);
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <Grid.Row divided>
                    <Grid.Column computer='5' tablet='7' mobile='8'>
                        <Header as='h3' attached='top' icon='info circle' content='Aggiungi i consumabili' />
                        <Segment attached textAlign='center'>
                            {this.renderElencoConsumabili()}
                            <Container textAlign='right'>
                                <Divider hidden />
                                <Button icon="cart" content="Aggiungi" color='teal' onClick={this.onAggiungiClick} />
                            </Container>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column computer='5' tablet='7' mobile='8'>
                        <Header as='h3' attached='top' icon='shopping cart' content='Riepilogo dei consumabili selezionati' />
                        <Segment attached>
                            <RiepilogoOrdine attached={true} />
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column textAlign='center'>
                        <Button primary content="Ordina per un'altra macchina" onClick={this.onSelezionaAltraMacchinaClick} style={{ marginRight: 15 }} />
                        <Button primary content='Conferma' onClick={this.onConfermaClick} />
                    </Grid.Column>
                </Grid.Row>
            </React.Fragment>
        )
    }

    renderElencoConsumabili() {
        const attrezzaturaSenzaConsumabili = this.props.consumabili.length === 0;

        return attrezzaturaSenzaConsumabili ? (
            <Header as='h2' textAlign='center' dividing>
                <Icon name='warning sign' />
                <Header.Content>
                    Nessun consumabile
                    <Header.Subheader>Per la matricola selezionata non è possibile ordinare consumabili</Header.Subheader>
                </Header.Content>
            </Header>
        ) : (
                this.props.consumabili.map(consumabile => this.renderConsumabile('print', consumabile))
            );
    }

    renderConsumabile(
        icon: SemanticICONS,
        consumabile: ConsumabileMatricola) {
        return (
            <React.Fragment key={consumabile.codice}>
                <Input
                    fluid
                    placeholder="Quantità"
                    className="input-qta"
                    labelPosition='right'
                    onKeyPress={this.onKeyPress}
                    onChange={(_, data) => this.onQtaChange(consumabile.codice, data.value)}
                    value={consumabile.quantita === 0 ? '' : consumabile.quantita}
                >
                    <Label color='teal' style={{ width: 180, textAlign: 'right' }}>{consumabile.descrizione}</Label>
                    <input type='number' />
                    <Label icon={icon} style={{ backgroundColor: consumabile.coloreSfondo, color: consumabile.coloreIcona }} />
                </Input>
                <Divider hidden fitted />
            </React.Fragment>
        )
    }

    onSelezionaAltraMacchinaClick() {
        if (!this.canContinue()) {
            return;
        }

        const { onGoBack } = this.props;
        if (onGoBack) {
            onGoBack(0);
        }
    }

    onConfermaClick() {
        if (!this.canContinue()) {
            return;
        }

        const { onConsumabiliInseriti } = this.props;
        if (onConsumabiliInseriti) {
            onConsumabiliInseriti();
        }
    }

    canContinue() {
        const richiestaConferma = Object.values(this.state)
            .reduce((accumulator, value) => accumulator || value.some(c => c.quantita > 0), false);

        if (richiestaConferma) {
            return window.confirm('Proseguendo verranno perse le quantità non aggiunte al carrello. Proseguire?');
        }

        return true;
    }

    onAggiungiClick() {
        if (!this.state.consumabili.some(c => c.quantita > 0)) {
            return window.confirm("Nessun consumabile inserito, non c'è niente da aggiungere");
        }

        var dettagli: OrdineRiga[] = [];

        this.state.consumabili.forEach(consumabile => {
            if (consumabile.quantita > 0) {
                const dettaglio: OrdineRiga = {
                    idSpecifica: this.props.matricola.idSpecifica,
                    codice: consumabile.codice,
                    descrizione: consumabile.descrizione,
                    colore: consumabile.coloreSfondo,
                    quantita: consumabile.quantita
                };
                dettagli.push(dettaglio);
            }
        });
        
        this.props.addConsumabiliToCart(this.props.matricola, dettagli);

        this.setState(state => {
            state.consumabili.forEach(c => c.quantita = 0);
            return {
                consumabili: state.consumabili
            }
        });
    }

    onKeyPress(event: any) {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        if (keyValue === ',' || keyValue === '.') {
            event.preventDefault();
        } else if (isNaN(Number(keyValue))) {
            event.preventDefault();
        }
    }

    onQtaChange(
        codice: string,
        value: string) {
        this.state.consumabili.forEach(cons => {
            if (cons.codice === codice) {
                const qta = Number(value);
                cons.quantita = qta < 0 ? 0 : qta;
            }
        });

        this.setState({
            ...this.state,
        });
    }
}

export default connector(SelezionaConsumabiliMatricola);